module.exports = __webpack_public_path__ + "assets/rosette-icon.542ee024.svg";